<script setup>
import { cn } from '@/lib/utils';
import { DropdownMenuItem, useForwardProps } from 'radix-vue';
import { computed } from 'vue';

const props = defineProps({
    disabled: {
        type: Boolean,
        required: false,
    },
    textValue: {
        type: String,
        required: false,
        default: '',
    },
    asChild: {
        type: Boolean,
        required: false,
    },
    as: {
        type: null,
        required: false,
        default: "div",
    },
    class: {
        type: null,
        required: false,
        default: "",
    },
    inset: {
        type: Boolean,
        required: false,
    },
});

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props;

    return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <DropdownMenuItem
        v-bind="forwardedProps"
        :class="
            cn(
                'relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&>svg]:size-4 [&>svg]:shrink-0',
                inset && 'pl-8',
                props.class,
            )
        "
    >
        <slot />
    </DropdownMenuItem>
</template>
